export enum RETURNED_PAYMENT_SETTING_TYPE {
    Account = 1,
    Property = 2,
    Unit = 3
}
